module.exports = __webpack_public_path__ + "img/score-tip1.39875e16.png";